export default "__VITE_ASSET__bCT5mMhm__"